import React from 'react';
import TeamItems from './TeamItems';
import TeamsHead from './TeamsHead';

const TeamsBody = () => {
    return (
        <>
            <TeamsHead />
            <TeamItems />
        </>
    );
};

export default TeamsBody;
